import React, { useState } from 'react'
import { AlertTriangle, Bug, CheckCircle } from 'lucide-react'

interface ReportProblemButtonProps {
  onReportProblem: () => void
  isReported?: boolean
  className?: string
}

export default function ReportProblemButton({ onReportProblem, isReported = false, className = '' }: ReportProblemButtonProps) {
  const [isReporting, setIsReporting] = useState(false)

  const handleReport = async () => {
    setIsReporting(true)
    try {
      await onReportProblem()
    } finally {
      setIsReporting(false)
    }
  }

  if (isReported) {
    return (
      <div className={`flex items-center space-x-2 text-green-600 ${className}`}>
        <CheckCircle className="w-4 h-4" />
        <span className="text-sm font-medium">Problem Reported</span>
      </div>
    )
  }

  return (
    <button
      onClick={handleReport}
      disabled={isReporting}
      className={`flex items-center space-x-2 px-3 py-1.5 text-sm font-medium text-orange-700 bg-orange-100 border border-orange-200 rounded-md hover:bg-orange-200 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors ${className}`}
    >
      {isReporting ? (
        <>
          <div className="w-4 h-4 border-2 border-orange-600 border-t-transparent rounded-full animate-spin" />
          <span>Reporting...</span>
        </>
      ) : (
        <>
          <Bug className="w-4 h-4" />
          <span>Report Problem</span>
        </>
      )}
    </button>
  )
}
